import { render } from "./VideoCompany.vue?vue&type=template&id=1e82d5a8&scoped=true"
import script from "./VideoCompany.vue?vue&type=script&lang=js"
export * from "./VideoCompany.vue?vue&type=script&lang=js"

import "./VideoCompany.vue?vue&type=style&index=0&id=1e82d5a8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e82d5a8"]])

export default __exports__